export default [{
  key: "selection",
  width: 60,
  fixed: "left",
  action: true,
  toggleShow: true
}, {
  key: "img",
  title: "图片",
  width: 60,
  toggleShow: true,
  render: (h, params) => {
    let img = params.value.img;
    return h("div", {}, [
      img ? [h("img", {
        style: {
          height: "100%",
          width: "100%"
        },
        attrs: {
          src: "http://imgs.85804669.com/product/" + img.substr(0, 5) + '/' + img
        }
      })] : ""
    ]);
  }
}, {
  key: "name",
  title: "样品名称",
  width: 100,
  toggleShow: true,
}, {
  key: "name_en",
  title: "样品编号",
  width: 100,
  toggleShow: false,
}, {
  key: "number",
  title: "厂家货号",
  width: 90,
  toggleShow: true,
}, {
  key: "article_number",
  title: "所属平台",
  width: 90,
  toggleShow: true,
}, {
  key: "exworks_price",
  title: "产品包装",
  width: 90,
  toggleShow: true,
}, {
  key: "carton_cubic_meter",
  title: "出厂价",
  width: 80,
  toggleShow: true,
}, {
  key: "pack_specification",
  title: "外箱规格",
  toggleShow: false,
  render: (h, params) => {
    return params.value.pack_length && params.value.pack_width && params.value.pack_height ?
      h("div", {}, parseFloat(params.value.pack_length) + "×" + parseFloat(params.value.pack_width) + "×" + parseFloat(params.value.pack_height)) : "";
  }
}, {
  key: "operation",
  title: "操作",
  width: 80,
  fixed: "right",
  toggleShow: false,
}];